<template>
  <Modal v-model="modalValue" title="选择图标" width="900" @on-cancel="modalCancel">
    <Input placeholder="图标关键字" v-model="keyword" style="margin-bottom:15px; width:50%" icon="ios-search"></Input>

    <div class="icons">
      <div
        class="icon-item"
        :class="[item.text == icon ? 'icon-item-active' : '']"
        v-for="(item, index) in filterIconList"
        :key="index"
        @click="chooseIcon(item.text)"
      >
        <i :class="`ivu-icon ${item.name}`" style="font-size: 32px"></i>
        <p>{{ item.text }}</p>
      </div>
    </div>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import iconList from './icon'
  export default {
    name: 'add-card',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      // 默认icon
      defaultIcon: {
        type: [String],
        default: '',
      },
    },
    data() {
      return {
        keyword: '',
        icon: '', // 选择的icon
        iconList: iconList,
      }
    },
    methods: {
      // 提交
      modalConfirm() {
        this.$emit('on-success', this.icon)
        this.modalCancel()
      },
      modalCancel() {
        this.modalValue = false
      },
      // 选择图标
      chooseIcon(text) {
        if (this.icon == text) return (this.icon = '')
        this.icon = text
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
      filterIconList() {
        const keyword = this.keyword.toLowerCase()
        return this.iconList.filter(item => item.text.toLowerCase().includes(keyword))
      },
    },
    watch: {
      defaultIcon(val) {
        if (val != '') this.icon = val
      },
    },
  }
</script>

<style scoped lang="less">
  .icons {
    display: flex;
    justify-content: left;
    text-align: center;
    flex-wrap: wrap;
    max-height: 500px;
    overflow-y: scroll;
    .icon-item {
      margin: 6px 6px 6px 0;
      width: 135px;
      text-align: center;
      list-style: none;
      height: 100px;
      cursor: pointer;
      color: #5c6b77;
      transition: all 0.2s ease;
      position: relative;
      padding: 10px 0;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-direction: column;
    }
    .icon-item:hover {
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
    }
    p {
      padding-top: 10px;
    }
    .icon-item-active {
      color: #fff;
      background: #2d8cf0;
    }
  }
</style>
